export default __webpack_public_path__ + "static/media/JAS0200.34I-43420_-25978_0.49396e6c.jpg";